import React, { Component } from 'react'
import classnames from 'classnames'

import { IonIcon, Button } from 'controls'
import { image } from 'services'

import { amenities as amenitiesStyles, amenity as amenityStyle } from './styles'

const AMENITIES_TO_LIST = 9

const Amenity = ({ amenity: { name } , className }) => {
  return (
    <div className={classnames("amenity", className)}>
      <IonIcon icon="md-checkmark-circle-outline" /> {name}
      <style jsx>{amenityStyle}</style>
    </div>
  )
}
class Amenities extends Component {
  constructor(props) {
    super(props)
    this.state = {
      viewMore: false
    }
  }

  getViewComponent = viewMore =>
    viewMore
      ? [
          <span key="span">Ver menos amenidades</span>,
          <IonIcon icon="ios-arrow-up" key="icon" />
        ]
      : [
          <span key="span">Ver más amenidades</span>,
          <IonIcon icon="ios-arrow-down" key="icon" />
        ]

  render() {
    const { amenities, className } = this.props
    const { viewMore } = this.state

    const amenitiesToList = viewMore
      ? amenities
      : amenities.slice(0, AMENITIES_TO_LIST)
    return (
      <section className={classnames("amenities", className)}>
        {amenitiesToList.map((a, i) => (
          <Amenity amenity={a} key={i} className={className}/>
        ))}
        {amenities.length > AMENITIES_TO_LIST && (
          <Button
            fullWidth
            color="none"
            className="see-more-button"
            onClick={() => this.setState({ viewMore: !viewMore })}
          >
            {this.getViewComponent(viewMore)}
          </Button>
        )}
        <style jsx>{amenitiesStyles}</style>
      </section>
    )
  }
}
export default Amenities
